import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Licenses from './pages/Licenses';
import Activations from './pages/Activations';
import Logs from './pages/Logs';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Health from './pages/Health';

import { ResetPassword } from './pages/ResetPassword';
import { Register } from './pages/Register';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="licenses" element={<Licenses />} />
              <Route path="activations" element={<Activations />} />
              <Route path="users" element={<Users />} />

              <Route path="logs" element={<Logs />} />
              <Route path="settings" element={<Settings />} />
              <Route path="health" element={<Health />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 